/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Secure_AccessInputs */

const en_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secure Access`)
};

const es_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso seguro`)
};

const fr_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès sécurisé`)
};

const de_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherer Zugang`)
};

const ja_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全なアクセス`)
};

const zh_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全访问`)
};

const ar_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وصول آمن`)
};

const id_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Aman`)
};

const it_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso Sicuro`)
};

const ru_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасный доступ`)
};

const pt_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso Seguro`)
};

const ko_secure_access = /** @type {(inputs: Secure_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전한 접근`)
};

/**
* | output |
* | --- |
* | "Secure Access" |
*
* @param {Secure_AccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const secure_access = /** @type {((inputs?: Secure_AccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Secure_AccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_secure_access(inputs)
	if (locale === "es") return es_secure_access(inputs)
	if (locale === "fr") return fr_secure_access(inputs)
	if (locale === "de") return de_secure_access(inputs)
	if (locale === "ja") return ja_secure_access(inputs)
	if (locale === "zh") return zh_secure_access(inputs)
	if (locale === "ar") return ar_secure_access(inputs)
	if (locale === "id") return id_secure_access(inputs)
	if (locale === "it") return it_secure_access(inputs)
	if (locale === "ru") return ru_secure_access(inputs)
	if (locale === "pt") return pt_secure_access(inputs)
	return ko_secure_access(inputs)
});